import { Document } from "../../models";

export type QuestionStatus = 'no-comment' | 'answering' | 'answered'

export const getQuestionStatus = (document: Document): QuestionStatus => {

    if (document.selectedComment && document.commentsCounter > 0) {
        return 'answered'
    } else if (document.commentsCounter > 1) {
        return 'answering'
    }
    return 'no-comment'
}